import { InjectionToken, Signal } from '@angular/core';
import { Icons } from '../ce-icon/ICONLIB';

export type Action = {
    label: string;
    action: () => void;
    icon?: keyof Icons;
    isDisabled?: () => boolean;
};

/**
 * `'split-view'` (default) horizontally offsets the panel to compensate for
 * the main app shell's side navigation (matching the split-view content
 * layout). `'fullscreen'` skips that offset and lifts the panel's z-index so
 * it can render above full-screen takeovers (e.g. the site geolocation
 * editor).
 */
export type ActionPanelLayout = 'split-view' | 'fullscreen';

export type ActionPanelData = {
    helperText: Signal<string>;
    prefixIcon?: keyof Icons;
    isDisabled: Signal<boolean>;
    primaryAction: Action;
    secondaryAction: Action;
    moreActions: Action[];
    layout?: ActionPanelLayout;
};

export const ACTION_PANEL_DATA = new InjectionToken<ActionPanelData>('ACTION_PANEL_DATA');
